import React, { Component } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Typography
} from '@material-ui/core';
import { Delete, Save, Cancel } from '@material-ui/icons';
import moment from 'moment';
import { getHolidaysUseCase, addHolidayUseCase } from '../services/getHolidaysUseCase';
import { deleteHolidayUseCase } from '../services/deleteHolidayUseCase';

class HolidaysDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            holidays: [],
            loading: true,
            addingNew: false,
            newHoliday: {
                date: '',
                description: ''
            }
        };
    }

    componentDidMount() {
        this.loadHolidays();
    }

    loadHolidays = async () => {
        this.setState({ loading: true });
        try {
            // Get holidays for the entire year
            const startDate = moment().startOf('year').toDate();
            const endDate = moment().endOf('year').add(1, 'year').toDate();
            const holidays = await getHolidaysUseCase(startDate, endDate);

            // Sort by date
            holidays.sort((a, b) => a.date - b.date);

            this.setState({ holidays, loading: false });
        } catch (error) {
            console.error('Error loading holidays:', error);
            this.setState({ loading: false });
        }
    }

    handleDelete = async (holidayId) => {
        if (window.confirm('¿Está seguro de eliminar este día festivo?')) {
            try {
                await deleteHolidayUseCase(holidayId);
                this.loadHolidays();
            } catch (error) {
                console.error('Error deleting holiday:', error);
                alert('Error al eliminar día festivo');
            }
        }
    }

    handleAddNew = () => {
        this.setState({ addingNew: true });
    }

    handleCancelAdd = () => {
        this.setState({
            addingNew: false,
            newHoliday: {
                date: '',
                description: ''
            }
        });
    }

    handleSaveNew = async () => {
        const { newHoliday } = this.state;

        if (!newHoliday.date) {
            alert('La fecha es obligatoria');
            return;
        }

        try {
            const dateObj = moment(newHoliday.date).startOf('day').toDate();
            await addHolidayUseCase({
                date: dateObj,
                description: newHoliday.description
            });
            this.setState({
                addingNew: false,
                newHoliday: {
                    date: '',
                    description: ''
                }
            });
            this.loadHolidays();
        } catch (error) {
            console.error('Error adding holiday:', error);
            alert('Error al añadir día festivo');
        }
    }

    handleNewChange = (field, value) => {
        this.setState({
            newHoliday: {
                ...this.state.newHoliday,
                [field]: value
            }
        });
    }

    render() {
        const { holidays, loading, addingNew, newHoliday } = this.state;

        return (
            <div>
                <div style={{ marginBottom: '16px', textAlign: 'right' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleAddNew}
                        disabled={addingNew}
                    >
                        Añadir Día Festivo
                    </Button>
                </div>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Paper style={{ overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Fecha</strong></TableCell>
                                    <TableCell><strong>Descripción</strong></TableCell>
                                    <TableCell align="right"><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {addingNew && (
                                    <TableRow style={{ backgroundColor: '#e3f2fd' }}>
                                        <TableCell>
                                            <TextField
                                                type="date"
                                                value={newHoliday.date}
                                                onChange={(e) => this.handleNewChange('date', e.target.value)}
                                                size="small"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={newHoliday.description}
                                                onChange={(e) => this.handleNewChange('description', e.target.value)}
                                                size="small"
                                                fullWidth
                                                placeholder="Ej: Año Nuevo, Navidad..."
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={this.handleSaveNew} color="primary" size="small">
                                                <Save />
                                            </IconButton>
                                            <IconButton onClick={this.handleCancelAdd} size="small">
                                                <Cancel />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {holidays.map((holiday) => (
                                    <TableRow key={holiday.id}>
                                        <TableCell>
                                            {moment(holiday.date).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>{holiday.description || '-'}</TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                onClick={() => this.handleDelete(holiday.id)}
                                                color="secondary"
                                                size="small"
                                            >
                                                <Delete />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {holidays.length === 0 && !addingNew && (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            <Typography color="textSecondary">
                                                No hay días festivos registrados
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                )}
            </div>
        );
    }
}

export default HolidaysDialog;
